import React, { Component } from 'react';

export default class extends Component {
    state = {  }
    render() {
        return (
            <div className="contentRoutesContainer">
                <h2>Sobre o Sistema</h2>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/SobrePage.js